import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import { Grid, Button, Message, Container, Header, Image } from 'semantic-ui-react';
import FormsInputsText from '../../component/forms/inputs/text/forms_inputs_text';
import { submiValidateAdminActivation, validateAdminActivation } from '../../actions';

class AdminRegisterPassword extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.validateId()
    }
    validateId() {
        const activationId = this.props.match.params.activationId
        let errorMessage = 'Invalid Link'
        if (!activationId) this.props.history.push(`/?info=${errorMessage}`);
        validateAdminActivation(this.props.match.params.activationId, (success, error) => {
            if (error.errorMessage && error.errorMessage === "Invalid Activation Link") this.props.history.push(`/?info=${error.errorMessage}`);
        })
    }
    render() {
        return (
             <Container style={{ paddingTop: '2.5em' }}>
                <Image src="/groupcare_logo_hor.jpg" size="medium"/>
                <Header as='h2' block>
                    Finish Admin User Registration
                </Header>

                <Grid centered columns={1}>
                    <Grid.Column>
                          <Formik
                            initialValues={{
                                adminPassword: '',
                                reAdminPassword: ''
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            onSubmit={(values, actions) => {
                                submiValidateAdminActivation(this.props.match.params.activationId, values.adminPassword, (success, error) => {
                                    const successInfo = 'Successfully Registered Admin, please re-login'
                                    if (success) this.props.history.push(`/?info=${successInfo}`)
                                    if (error) this.props.history.push(`/?info=${error.errorMessage}`)
                                })
                            }}
                            validate={(values) => {
                                let error = {};
                                if (values.adminPassword !== values.reAdminPassword) error.reAdminPassword = 'Password Mismatch'
                                return error
                            }}
                            render={({
                                values,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue,
                            }) => (
                                <Form>
                                    <Message warning>
                                        <p>
                                            Please finish your administrator user registration by creating password
                                        </p>
                                    </Message>
                                    <Field 
                                        name="adminPassword" 
                                        label="New Password" 
                                        type="password"
                                        component={FormsInputsText} 
                                        secondaryLabel="" />
                                    <br />
                                    <Field 
                                        name="reAdminPassword" 
                                        label="Re-enter New Password" 
                                        type="password"
                                        component={FormsInputsText} 
                                        secondaryLabel="" />
                                    <br />
                                    <Button
                                        onClick={() => (this.props.activeMenu === 'retrieveUserId' && setFieldValue('loginId', '-'))}
                                        className='success-btn text-white w-100'
                                        type="submit"
                                        disabled={isSubmitting}
                                        loading={isSubmitting}>
                                        {'Submit'}
                                    </Button>
                                </Form>
                            )}
                        />
                    </Grid.Column>
                </Grid>
            </Container>
          
        )
    }
}
function mapStateToProps(state) {
    return {
        userData: state.user.user,
    };
}
export default connect(mapStateToProps, {
})(withRouter(AdminRegisterPassword));